export const NORTH_AMERICA_COUNTRIES = ['US', 'CA'];

export enum RegistrationStage {
  NotSubmitted = 0,
  ReviewingInfo = 1,
  RegistrationComplete = 2,
  DataError = 3,
}

export enum RegistrationTitle {
  NotApproved = 'Required information for US-based businesses',
  ApprovedStatus = 'Businesses registered for SMS',
}
export enum RegistrationContent {
  NotApproved = 'To send SMS messages to customers, more details about your business are required. Update your business info to send SMS messages.',
  ApprovedStatus = 'You can now access SMS features. Contact support if you need to make changes to your authorized business representative information.',
}
